import { Channels } from '@global/utils/nativescriptHost/nativescript-host';

export const handleDone = (eventSender: Channels | undefined) => () => eventSender?.navigate({ action: 'goBack' });
